import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { locales, localeNames, type Locale } from '@/i18n/config';

export function LanguageToggle() {
  const { i18n } = useTranslation();

  const currentLocale = i18n.language as Locale;
  const currentIndex = locales.indexOf(currentLocale);
  const shortLabel = currentLocale === 'pt-BR' ? 'PT' : 'EN';

  const toggle = () => {
    const nextIndex = (currentIndex + 1) % locales.length;
    const nextLocale = locales[nextIndex];
    i18n.changeLanguage(nextLocale);
    localStorage.setItem('language', nextLocale);
  };

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 rounded-md border bg-background px-2.5 py-1.5 text-sm font-medium shadow-sm hover:bg-accent hover:text-accent-foreground transition-colors"
      title={localeNames[currentLocale]}
    >
      <Globe className="h-4 w-4" />
      <span>{shortLabel}</span>
    </button>
  );
}
